import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-erase',
  templateUrl: './erase.component.html',
  styleUrls: ['./erase.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EraseIconComponent {}
